// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__AtibE","label":"Radio_label__3HC8w","checkMark":"Radio_checkMark__3qcpj","disabled":"Radio_disabled__1Xges"};